import { render } from "./RevealPassword.vue?vue&type=template&id=15b2ccea&ts=true"
import script from "./RevealPassword.vue?vue&type=script&lang=ts"
export * from "./RevealPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/RevealPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15b2ccea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15b2ccea', __exports__)) {
    api.reload('15b2ccea', __exports__)
  }
  
  module.hot.accept("./RevealPassword.vue?vue&type=template&id=15b2ccea&ts=true", () => {
    api.rerender('15b2ccea', render)
  })

}


export default __exports__